module.exports = __webpack_public_path__ + "img/tekenaars-ico.6ccf5d8e.svg";